import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import CircularProgress from 'material-ui/CircularProgress';
import IconButton from 'material-ui/IconButton';

const tableState = {
    fixedHeader: true,
    fixedFooter: true,
    stripedRows: false,
    showRowHover: false,
    selectable: true,
    multiSelectable: true,
    enableSelectAll: true,
    deselectOnClickaway: false,
    height: '500px',
};

class BranchesTableView extends React.Component {
    static propTypes = {
        actions: PropTypes.object,
        receipts: PropTypes.object,
        selectedReceipts: PropTypes.object,
        selectionEnabled: PropTypes.bool,
        isFetching: PropTypes.bool,
        onRowSelection: PropTypes.func,
    };

    constructor(props) {
        super(props);
    }

    longDateFormat(date) {
        return moment(date).format('DD.MM.YY');
    }

    dateFromString(string) {
        return moment(string);
    }

    formatDate(date) {
        return moment(date).format('DD.MM.YYYY');
    }

    render = () => {
        const branchNodes = this.props.branches.valueSeq().map(branch => (
            <TableRow key={branch.get('branch_id')}>
                <TableRowColumn>
                    <div>{branch.get('branch_id')}</div>
                </TableRowColumn>
                <TableRowColumn>
                    {!branch.get('is_uploading') && (
                        <IconButton
                            key={branch.get('branch_id')}
                            iconStyle={{
                                color: 'black',
                            }}
                            iconClassName="material-icons"
                            tooltipPosition="bottom-center"
                            tooltip=""
                            onClick={this.props.deleteBranch(branch.get('branch_id'))}>
                            delete
                        </IconButton>
                    )}
                </TableRowColumn>
                <TableRowColumn>
                    {!branch.get('is_uploading') && (
                        <span>
                            {' '}
                            {this.formatDate(branch.get('updated_at'))} / <br />{' '}
                            {branch.get('number_of_articles')} Artikel
                        </span>
                    )}
                    {branch.get('is_uploading') && <span>Wird aktualisiert ...</span>}
                </TableRowColumn>
                <TableRowColumn>
                    {!branch.get('is_uploading') && (
                        <IconButton
                            iconStyle={{
                                color: 'black',
                            }}
                            iconClassName="material-icons"
                            tooltipPosition="bottom-center"
                            tooltip=""
                            onClick={this.props.uploadArticles(branch.get('branch_id'))}>
                            cloud
                        </IconButton>
                    )}
                    {branch.get('is_uploading') && <CircularProgress size={0.25} />}
                </TableRowColumn>
            </TableRow>
        ));

        const { isFetching } = this.props;

        return (
            <Table
                height={tableState.height}
                fixedHeader={tableState.fixedHeader}
                fixedFooter={tableState.fixedFooter}
                selectable={false}
                multiSelectable={tableState.multiSelectable}
                onRowSelection={this.props.onRowSelection}>
                <TableHeader
                    enableSelectAll={tableState.enableSelectAll}
                    displaySelectAll={false}
                    adjustForCheckbox={false}>
                    {isFetching && (
                        <TableRow>
                            <TableHeaderColumn
                                colSpan="4"
                                tooltip="Super Header"
                                style={{
                                    textAlign: 'center',
                                }}>
                                <div
                                    className="progress-indicator-wrapper"
                                    style={{
                                        padding: '5px',
                                    }}>
                                    <CircularProgress mode="indeterminate" size={0.5} />
                                </div>
                            </TableHeaderColumn>
                        </TableRow>
                    )}
                    <TableRow>
                        <TableHeaderColumn tooltip="Filial-Nr.">Filial-Nr.</TableHeaderColumn>
                        <TableHeaderColumn tooltip="Bearbeiten">Bearbeiten</TableHeaderColumn>
                        <TableHeaderColumn tooltip="Bearbeiten">
                            Artikeldatenbestand /<br /> Anzahl Artikel
                        </TableHeaderColumn>
                        <TableHeaderColumn tooltip="Artikel-Upload">
                            Artikel-Upload
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody
                    deselectOnClickaway={tableState.deselectOnClickaway}
                    displayRowCheckbox={false}>
                    {branchNodes}
                </TableBody>
            </Table>
        );
    };
}
export default BranchesTableView;
